var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyundaiValorGente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19600",
    "data-name": "Group 19600",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.269,
    height: 55.218,
    viewBox: "0 0 55.269 55.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9081",
    "data-name": "Path 9081",
    className: "cls-1",
    d: "M20.991,86.22H7.174a.986.986,0,0,1-.986-.986V79.119a5.766,5.766,0,0,1,5.76-5.76h8.225a5.745,5.745,0,0,1,2.394.523.986.986,0,0,1-.821,1.792,3.776,3.776,0,0,0-1.573-.345H11.947A3.791,3.791,0,0,0,8.16,79.116v5.128H20.991a.986.986,0,0,1,0,1.972Z",
    transform: "translate(-6.188 -31.004)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9082",
    "data-name": "Path 9082",
    className: "cls-1",
    d: "M82.858,86.221H69.04a.986.986,0,0,1,0-1.972H81.871V79.12a3.791,3.791,0,0,0-3.787-3.787H69.859a3.738,3.738,0,0,0-1.573.345.986.986,0,1,1-.821-1.792,5.707,5.707,0,0,1,2.394-.523h8.225a5.766,5.766,0,0,1,5.76,5.76v6.115a.986.986,0,0,1-.986.986Z",
    transform: "translate(-28.575 -31.006)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9083",
    "data-name": "Path 9083",
    className: "cls-1",
    d: "M17.306,67.445a7.738,7.738,0,1,1,7.737-7.737A7.747,7.747,0,0,1,17.306,67.445Zm0-13.5a5.766,5.766,0,1,0,5.765,5.767A5.773,5.773,0,0,0,17.306,53.94Z",
    transform: "translate(-7.434 -23.115)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9084",
    "data-name": "Path 9084",
    className: "cls-1",
    d: "M73.592,67.445a7.738,7.738,0,1,1,7.74-7.737A7.747,7.747,0,0,1,73.592,67.445Zm0-13.5a5.766,5.766,0,1,0,5.767,5.767A5.771,5.771,0,0,0,73.592,53.94Z",
    transform: "translate(-28.193 -23.115)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9085",
    "data-name": "Path 9085",
    className: "cls-1",
    d: "M53.087,86.221H35.322a.986.986,0,0,1-.986-.986V79.12a5.762,5.762,0,0,1,5.757-5.757h8.225a5.762,5.762,0,0,1,5.757,5.757v6.115a.986.986,0,0,1-.986.986ZM36.308,84.248H52.1V79.12a3.79,3.79,0,0,0-3.785-3.785H40.091a3.79,3.79,0,0,0-3.785,3.785v5.128Z",
    transform: "translate(-16.569 -31.006)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9086",
    "data-name": "Path 9086",
    className: "cls-1",
    d: "M45.447,67.445a7.738,7.738,0,1,1,7.737-7.737A7.747,7.747,0,0,1,45.447,67.445Zm0-13.5a5.766,5.766,0,1,0,5.765,5.767A5.773,5.773,0,0,0,45.447,53.94Z",
    transform: "translate(-17.812 -23.115)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9087",
    "data-name": "Path 9087",
    className: "cls-1",
    d: "M49.373,44.295H43.931a2.961,2.961,0,0,1-2.959-2.959V39.354a.986.986,0,0,1,.986-.986h2.207a.986.986,0,0,1,0,1.972h-1.22v1a.986.986,0,0,0,.986.986h5.442a.986.986,0,0,0,.986-.986v-1H49.175a.986.986,0,0,1,0-1.972h2.17a.986.986,0,0,1,.986.986v1.982A2.961,2.961,0,0,1,49.373,44.295Z",
    transform: "translate(-19.016 -18.099)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9088",
    "data-name": "Path 9088",
    className: "cls-1",
    d: "M47.165,28.492h-5.01a.986.986,0,0,1-.986-.986V27.3a6.516,6.516,0,0,0-2.416-4.921,9.147,9.147,0,1,1,11.778.035A6.42,6.42,0,0,0,48.151,27.3v.212a.986.986,0,0,1-.986.986ZM43.1,26.519h3.117a8.447,8.447,0,0,1,3.047-5.627A7.171,7.171,0,0,0,46.1,8.367a7.234,7.234,0,0,0-6.006,1.5,7.175,7.175,0,0,0-.074,11.006A8.589,8.589,0,0,1,43.1,26.524Z",
    transform: "translate(-17.006 -6.256)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9089",
    "data-name": "Path 9089",
    className: "cls-1",
    d: "M27.092,20.722H25.548a.986.986,0,1,1,0-1.972h1.543a.986.986,0,0,1,0,1.972Z",
    transform: "translate(-12.964 -10.864)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9090",
    "data-name": "Path 9090",
    className: "cls-1",
    d: "M29.024,13.434a.979.979,0,0,1-.5-.138l-1.327-.789A.986.986,0,0,1,28.2,10.813l1.327.789a.985.985,0,0,1-.505,1.832Z",
    transform: "translate(-13.758 -7.885)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9091",
    "data-name": "Path 9091",
    className: "cls-1",
    d: "M28.024,28.306a.987.987,0,0,1-.54-1.815l1.294-.843A.987.987,0,0,1,29.856,27.3l-1.294.843a.983.983,0,0,1-.537.16Z",
    transform: "translate(-13.876 -13.349)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9092",
    "data-name": "Path 9092",
    className: "cls-1",
    d: "M72.4,20.722H70.853a.986.986,0,1,1,0-1.972H72.4a.986.986,0,1,1,0,1.972Z",
    transform: "translate(-29.673 -10.864)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9093",
    "data-name": "Path 9093",
    className: "cls-1",
    d: "M69.048,13.434a.985.985,0,0,1-.505-1.832l1.327-.789a.986.986,0,0,1,1.008,1.694l-1.327.789a.986.986,0,0,1-.5.138Z",
    transform: "translate(-29.007 -7.885)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9094",
    "data-name": "Path 9094",
    className: "cls-1",
    d: "M70.065,28.307a.983.983,0,0,1-.538-.16L68.233,27.3a.987.987,0,0,1,1.077-1.654l1.294.843a.987.987,0,0,1-.54,1.815Z",
    transform: "translate(-28.905 -13.349)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9095",
    "data-name": "Path 9095",
    className: "cls-1",
    d: "M49.424,34.154a.986.986,0,0,1-.986-.986V22.6a.986.986,0,1,1,1.972,0V33.168A.986.986,0,0,1,49.424,34.154Z",
    transform: "translate(-21.77 -11.918)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9096",
    "data-name": "Path 9096",
    className: "cls-1",
    d: "M50.551,23.574H45.127a.986.986,0,0,1,0-1.972h5.424a.986.986,0,0,1,0,1.972Z",
    transform: "translate(-20.185 -11.916)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyundaiValorGente);
export default __webpack_public_path__ + "static/media/hyundai-valor-gente.b6eaef58de5f4ac5c593e9f0ca89fe8f.svg";
export { ForwardRef as ReactComponent };